module.exports = __webpack_public_path__ + "static/keira-hodgkison.ce3e674e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keira-hodgkison.jpg
// module id = 668
// module chunks = 168707334958949